import { AppConfigDataClient } from '@aws-sdk/client-appconfigdata'
import { AwsSdkModule } from '@backend/aws'
import { Global, Module } from '@nestjs/common'
import { AppConfigConfig } from '../../config'
import { AppConfigService } from './service'

@Global()
@Module({
	imports: [AwsSdkModule.register({ client: new AppConfigDataClient(AppConfigConfig) })],
	providers: [AppConfigService],
	exports: [AppConfigService],
})
export class AppConfigModule {}

export { AppConfigService } from './service'
